import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Permission } from 'src/app/models/permission.model';
import { Constants } from 'src/app/shared/utils/constants';
import { CmsService } from '../cms.service';
import { NumNotRoundPipe } from 'src/app/shared/pipes/common.pipe';
import { ExcelExportService } from '../excel.export.service';
import { MamFollowerModel } from 'src/app/models/mam.approval.model';
declare var $: any;

@Component({
  selector: 'app-mam-pamm-follower',
  templateUrl: './mam-pamm-follower.component.html',
  styleUrls: ['./mam-pamm-follower.component.sass']
})
export class MamPammFollowerComponent implements OnInit {
  permission: Permission;
  detail: any;
  constructor(private appService: AppService) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {}

  onSelectedMAM(detail: any): void {
    this.detail = detail;
  }
}
